import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import {
  checkcin,
  checkphone,
  checknumCnssExist,
  addEmployee,
  checkemail,
} from "../../../../services/RHService/EmployeeService";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import { getPrimesWithStatus } from "../../../../services/RHService/PrimeService";
import getCurrentUserId from "../../../../reduxSaga/sagas/requests/currentUserId";
import { error } from "jquery";
const AddEmployee = () => {
  //situation familiale

  const [emailError, setEmailError] = useState("");
  const [cinError, setCinError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [numcnssError, setNumcinError] = useState("");
  const [prime, setPrime] = useState([]);
  const [selectedOption, setSelectedOption] = useState([]); // State to keep track of the selected option
  const [showInput, setShowInput] = useState(false);
  const [showInputNb, setShowInputNb] = useState(false);

  //Define the state variables for the form data
  const [formData, setFormData] = useState({
    gender: "",
    situationFamiliale: "",
    lastName: "",
    firstName: "",
    email: "",
    phone: "",
    cin: "",
    isAssured: false,
    dateNais: "",
    country: "",
    adr: "",
    postalCode: "",
    dateRec: "",
    numCnss: "",
    nbEnfantAcharge: 0,
    nbEnfantNonBoursier: 0,
    estEnfantAcharge: false,
    userPrimeModel: [],
  });

  const [inputList, setInputList] = useState([{ idPrime: 0, primeAmount: 0 }]);

  useEffect(() => {
    getPrimesWithStatus(getCurrentUserId())
      .then((response) => {
        setPrime(response.data);
      })
      .catch((error) => {
        console.log("error", error);
      });
  }, []);

  const handleSelectPrimeChange = (event, index) => {
    const target = event.target;
    const name = target.name;
    const value =
      target.type === "checkbox"
        ? target.checked
          ? target.value
          : ""
        : target.value;

    if (name === "idPrime") {
      if (!value) {
        const updatedInputList = [...inputList];
        updatedInputList.splice(index, 1); // Remove the element from the inputList
        setInputList(updatedInputList);
      } else {
        const updatedInputList = [...inputList];
        const existingItem = updatedInputList[index];
        if (existingItem) {
          updatedInputList[index] = {
            ...existingItem,
            idPrime: parseInt(value),
          };
        } else {
          updatedInputList[index] = {
            idPrime: parseInt(value),
            primeAmount: "",
          };
        }
        setInputList(updatedInputList);
      }
    } else if (name === "primeAmount") {
      const updatedInputList = [...inputList];
      updatedInputList[index] = {
        ...updatedInputList[index],
        primeAmount: value,
      };
      setInputList(updatedInputList);
    }
  };

  useEffect(() => {
    setFormData((prevState) => ({
      ...prevState,
      userPrimeModel: inputList,
    }));
  }, [inputList]);

  // useEffect(() => {}, [formData]);

  // Event handler to handle the select box change
  const handleSelectChange = (event) => {
    const { name, checked } = event.target;

    setSelectedOption((prevOption) => ({
      ...prevOption,
      [name]: checked,
    }));
    setFormData((prevData) => ({
      ...prevData,
      [name]: checked,
    }));
    if (name === "estEnfantAcharge") {
      setShowInput(checked);
    }
    if (name === "estEnfantNonBoursier") {
      setShowInputNb(checked);
    }
  };
  //Define an event handler function to update the state variables when the user inputs data into the form fields
  const handleInputChange = async (event) => {
    const target = event.target;
    const name = target.name;
    const value = target.type === "checkbox" ? target.checked : target.value;

    if (name === "isAssured" && value) {
      setFormData({ ...formData, isAssured: true });
    } else if (name === "gender") {
      setFormData({ ...formData, gender: value === "f" ? "femme" : "homme" });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const { dateNais, dateRec, ...otherFormData } = formData;
    const formattedFormData = {
      ...otherFormData,
      dateNais: moment(formData.dateNais).format("YYYY-MM-DD"),
      dateRec: moment(formData.dateRec).format("YYYY-MM-DD"),
      userId: JSON.parse(localStorage.getItem("user")).token.idUser,
    };
    // const age = moment().diff(moment(dateNais), "years");
    const isFormValid = validateForm(formattedFormData);
    // console.log(formData);
    if (!isFormValid) {
      return;
    }

    try {
      let checkNumCnssExists;
      const { email, cin, phone, numCnss } = formattedFormData;
      // const user = JSON.parse(localStorage.getItem("user"));
      const checkEmailExist = await checkemail(email, getCurrentUserId());
      const checkCinExist = await checkcin(cin, getCurrentUserId());
      const checkPhoneExist = await checkphone(phone, getCurrentUserId());
      if (numCnss) {
        checkNumCnssExists = await checknumCnssExist(
          numCnss,
          getCurrentUserId()
        );
      }

      if (checkNumCnssExists.data) {
        setNumcinError("Numéro de Cnss déjà existe");
        return;
      } else {
        setNumcinError("");
      }

      if (checkPhoneExist.data) {
        setPhoneError("Numéro de téléphone déjà existe");
        return;
      } else {
        setPhoneError("");
      }

      if (checkEmailExist.data) {
        setEmailError("Email déjà existe");
      } else {
        setEmailError("");
      }

      if (checkCinExist.data) {
        setCinError("Cin déjà existe");
        return;
      } else {
        setCinError("");
      }
      const currentDate = moment().format("YYYY-MM-DD");
      if (dateRec > currentDate) {
        toastr.error(
          "La date de recrutement doit être antérieure à la date d'aujourd'hui."
        );
        return;
      }
      console.log(formattedFormData);
      if (
        !checkEmailExist.data &&
        !checkCinExist.data &&
        !checkPhoneExist.data
      ) {
        addEmployee(getCurrentUserId(), formattedFormData)
          .then((response) => {
            toastr.success("Personnel ajouté avec succès.");
          })
          .catch((error) => {
            toastr.error("Erreur " + error);
          });
      }
    } catch (error) {
      toastr.error("Erreur lors de l'insertion.");
    }
  };
  //employee submit

  // validation
  const validateForm = (formData) => {
    const {
      gender,
      email,
      cin,
      adr,
      country,
      firstName,
      lastName,
      situationFamiliale,
      phone,
      postalCode,
    } = formData;

    if (
      !email ||
      !cin ||
      !adr ||
      !country ||
      !firstName ||
      !lastName ||
      !phone ||
      !gender ||
      !situationFamiliale ||
      postalCode === 0
    ) {
      toastr.error("Veuillez renseigner tous les champs.");
      return false;
    }

    if (phone.length !== 8 || !/^\d+$/.test(phone)) {
      toastr.error("Numéro de téléphone invalide : 8 chiffres");
      return false;
    }

    if (cin.length !== 8 || !/^\d+$/.test(cin)) {
      toastr.error("Numéro de carte d'identité invalide : 8 chiffres");
      return false;
    }

    if (!/^\d+$/.test(postalCode) || postalCode.toString().length !== 4) {
      toastr.error("Code Postal invalide : 4 chiffres");
      return false;
    }

    if (!/\S+@\S+\.\S+/.test(email)) {
      toastr.error('Email invalide : doit être de format "johnDoe@gmail.com"');
      return false;
    }

    return true;
  };
  return (
    <section className="content-wrapper" style={{ marginTop: "0" }}>
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="row"> Ajouter un employé</h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <i class="fa-solid fa-house"></i>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/" style={{ color: "black" }}>
                    Home
                  </Link>
                </li>
                <li className="breadcrumb-item active">
                  <Link to="/employeeList" style={{ color: "black" }}>
                    Liste des employés
                  </Link>
                </li>
                <li className="breadcrumb-item active">Ajouter un employé</li>
              </ol>
            </div>
          </div>
        </div>
      </div>

      <section className="content">
        <form onSubmit={handleSubmit}>
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card card-dark">
                  <div class="card-header">
                    <h4 class="card-title">Information générale</h4>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="card-body">
                        <div className="form-group">
                          <label for="exampleInputPassword1">Prénom </label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData.lastName}
                            onChange={handleInputChange}
                            name="lastName"
                            placeholder="Prénom"
                          />
                        </div>
                        <div className="form-group">
                          <label for="exampleInputPassword1">Nom </label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData.firstName}
                            onChange={handleInputChange}
                            name="firstName"
                            placeholder="Nom"
                          />
                        </div>
                        <div className="form-group">
                          <label>Date de naissance:</label>
                          <div
                            className="input-group date"
                            id="reservationdate"
                            data-target-input="nearest"
                          >
                            <input
                              type="date"
                              id="start"
                              value={formData.dateNais}
                              name="dateNais"
                              onChange={handleInputChange}
                              min="1900-01-01"
                              max="2100-12-31"
                              className="form-control "
                            />
                          </div>
                        </div>
                        <div className="form-group">
                          <label for="exampleSelectBorder">Genre </label>
                          <select
                            className="custom-select "
                            name="gender"
                            onChange={handleInputChange}
                          >
                            <option value="">--choisir le genre--</option>
                            <option value="h">Mr</option>
                            <option value="f">Mme</option>
                          </select>
                        </div>
                        <div className="form-group">
                          <label for="exampleSelectBorder">
                            Situation Familiale{" "}
                          </label>
                          <select
                            className="custom-select"
                            name="situationFamiliale"
                            onChange={handleInputChange}
                          >
                            <option value="">
                              --choisir la situation familiale--
                            </option>
                            <option value="Célibataire">Célibataire</option>
                            <option value="Marié">Marié</option>
                          </select>
                        </div>

                        <div className="form-group">
                          <label for="exampleInputPassword1">Email </label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData.email}
                            onChange={handleInputChange}
                            name="email"
                            placeholder="email"
                          />
                        </div>
                        {emailError && (
                          <p style={{ color: "red" }}>{emailError}</p>
                        )}

                        <div className="form-group">
                          <label for="exampleInputPassword1">
                            N° Téléphone
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData.phone}
                            onChange={handleInputChange}
                            name="phone"
                            placeholder="N° Téléphone"
                          />
                        </div>
                        {phoneError && (
                          <p style={{ color: "red" }}>{phoneError}</p>
                        )}

                        <div class="form-group">
                          <div className="custom-control custom-checkbox mt-5">
                            <input
                              className="custom-control-input custom-control-input-dark"
                              value={formData.isAssured}
                              onChange={handleInputChange}
                              type="checkbox"
                              id="customCheckbox7"
                              name="isAssured"
                            />
                            <label
                              for="customCheckbox7"
                              className="custom-control-label"
                            >
                              Assurance vie
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="card-body">
                        <div className="form-group">
                          <label for="exampleInputPassword1">CIN </label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData.cin}
                            onChange={handleInputChange}
                            name="cin"
                            placeholder="CIN"
                          />
                        </div>
                        {cinError && <p style={{ color: "red" }}>{cinError}</p>}

                        <div className="form-group">
                          <label for="exampleInputPassword1">Ville</label>
                          <input
                            type="text"
                            name="country"
                            value={formData.country}
                            onChange={handleInputChange}
                            className="form-control"
                            placeholder="Ville"
                          />
                        </div>
                        <div className="form-group">
                          <label for="exampleInputPassword1">Adresse</label>
                          <input
                            type="text"
                            name="adr"
                            value={formData.adr}
                            className="form-control"
                            onChange={handleInputChange}
                            placeholder="Adresse"
                          />
                        </div>
                        <div className="form-group">
                          <label for="exampleInputPassword1">Code postal</label>
                          <input
                            type="text"
                            name="postalCode"
                            value={formData.postalCode}
                            onChange={handleInputChange}
                            className="form-control"
                            placeholder="Code postal"
                          />
                        </div>

                        <div className="form-group">
                          <label>Date de recrutement:</label>
                          <div
                            className="input-group date"
                            data-target-input="nearest"
                          >
                            <input
                              type="date"
                              id="start"
                              value={formData.dateRec}
                              onChange={handleInputChange}
                              name="dateRec"
                              min="1900-01-01"
                              max="2100-12-31"
                              className="form-control "
                            />
                          </div>
                        </div>
                        <div className="form-group">
                          <label for="exampleInputPassword1">Matricule</label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData.matricule}
                            onChange={handleInputChange}
                            name="matricule"
                            placeholder="Matricule"
                          />
                        </div>
                        <div className="form-group">
                          <label for="exampleInputPassword1">N° CNSS</label>
                          <input
                            type="text"
                            name="numCnss"
                            value={formData.numCnss}
                            onChange={handleInputChange}
                            className="form-control"
                            placeholder="N° CNSS"
                          />
                        </div>
                        {numcnssError && (
                          <p style={{ color: "red" }}>{numcnssError}</p>
                        )}

                        <div className="col-md-12 mt-4">
                          <div class="icheck-dark d-inline ">
                            <input
                              type="radio"
                              id="radioPrimary1"
                              onChange={handleInputChange}
                              value="EMPLOYEE_RH"
                              name="role"
                            />
                            <label htmlFor="radioPrimary1">
                              Simple personnel
                            </label>
                          </div>
                          <div class="icheck-dark d-inline mx-2">
                            <input
                              type="radio"
                              id="radioPrimary2"
                              onChange={handleInputChange}
                              value="RESPONSABLE_RH"
                              name="role"
                            />
                            <label htmlFor="radioPrimary2">
                              Administrateur Ressource humaine
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card card-dark">
                  <div className="card-header">
                    <h4 className="card-title">Sitituation familiale</h4>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="card-body">
                        <div className="col-md-6">
                          <div className="row">
                            <div className="form-group">
                              <div className="custom-control custom-checkbox">
                                <input
                                  className="custom-control-input"
                                  type="checkbox"
                                  name="estChefDefamille"
                                  id="customCheckbox8"
                                  value={selectedOption.estChefDefamille}
                                  onChange={handleSelectChange}
                                />
                                <label
                                  htmlFor="customCheckbox8"
                                  className="custom-control-label"
                                >
                                  Chef de Famille
                                </label>
                              </div>
                              <div className="custom-control custom-checkbox">
                                <input
                                  type="checkbox"
                                  className="custom-control-input"
                                  name="estEnfantAcharge"
                                  id="customCheckbox9"
                                  value={selectedOption.estEnfantAcharge}
                                  onChange={handleSelectChange}
                                />
                                <label
                                  htmlFor="customCheckbox9"
                                  className="custom-control-label"
                                >
                                  Enfant à charge (&lt;20 ans)
                                </label>
                              </div>
                              {showInput && (
                                <div className="col-md-12">
                                  <input
                                    type="number"
                                    step="1"
                                    className="form-control form-control-border"
                                    value={formData.nbEnfantAcharge}
                                    onChange={handleInputChange}
                                    name="nbEnfantAcharge"
                                    placeholder="Nombre d'enfant à charge"
                                  />
                                </div>
                              )}
                              <div className="custom-control custom-checkbox">
                                <input
                                  type="checkbox"
                                  className="custom-control-input"
                                  name="estEnfantNonBoursier"
                                  id="customCheckbox10"
                                  value={selectedOption.estEnfantNonBoursier}
                                  onChange={handleSelectChange}
                                />
                                <label
                                  htmlFor="customCheckbox10"
                                  className="custom-control-label"
                                >
                                  Enfant Non boursier
                                </label>
                              </div>
                              {showInputNb && (
                                <div className="col-md-12">
                                  <input
                                    type="number"
                                    step="1"
                                    className="form-control form-control-border"
                                    name="nbEnfantNonBoursier"
                                    value={formData.nbEnfantNonBoursier}
                                    onChange={handleInputChange}
                                    placeholder="Nombre d'enfant Non boursier"
                                  />
                                </div>
                              )}

                              <div className="custom-control custom-checkbox">
                                <input
                                  className="custom-control-input"
                                  type="checkbox"
                                  name="estParentACharge"
                                  id="customCheckbox11"
                                  value={selectedOption.estParentACharge}
                                  onChange={handleSelectChange}
                                />
                                <label
                                  htmlFor="customCheckbox11"
                                  className="custom-control-label"
                                >
                                  Parent à charge
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card card-dark">
                  <div className="card-header">
                    <h4 className="card-title">Primes</h4>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="card-body">
                        {prime !== null && (
                          <div>
                            {prime.map((c, index) => (
                              <div key={c.id} className="row">
                                <div className="custom-control custom-checkbox">
                                  {" "}
                                  <input
                                    type="checkbox"
                                    className="custom-control-input"
                                    id={c.nomPrime}
                                    value={c.id}
                                    name="idPrime"
                                    onChange={(event) =>
                                      handleSelectPrimeChange(event, index)
                                    }
                                  />
                                  <label
                                    htmlFor={c.nomPrime}
                                    className="custom-control-label"
                                  >
                                    {c.nomPrime}
                                  </label>
                                </div>
                                <div className="col-md-2 mx-3 mt-2">
                                  <input
                                    type="text"
                                    className="form-control"
                                    onChange={(event) =>
                                      handleSelectPrimeChange(event, index)
                                    }
                                    name="primeAmount"
                                    placeholder="Montant de Prime"
                                  />
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card-footer">
            <button
              type="submit"
              className="btn btn-dark col-md-3 float-right"
              style={{ width: "auto" }}
            >
              Confirmer
            </button>
          </div>
        </form>
      </section>
    </section>
  );
};
export default AddEmployee;
